export default "__VITE_ASSET__DkLyKcAB__"